"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useCustomTheme } from "../../../core/design-system/CustomThemeProvider.js";
import { radius, spacing } from "../../../core/design-system/index.js";
import { StyledOption, StyledSelect } from "../../ui/design-system/elements.js";
export function CountrySelector({ countryCode, setCountryCode, }) {
    const selectRef = useRef(null);
    const { data: supportedCountries } = useQuery({
        queryKey: ["supported-sms-countries"],
        queryFn: async () => {
            const { supportedSmsCountries } = await import("./supported-sms-countries.js");
            return supportedSmsCountries;
        },
    });
    const supportedCountriesForSms = supportedCountries ?? [
        {
            countryIsoCode: "US",
            countryName: "United States",
            phoneNumberCode: 1,
        },
    ];
    return (_jsx(_Fragment, { children: _jsxs(Select, { ref: selectRef, name: "countries", id: "countries", value: countryCode, onChange: (e) => {
                setCountryCode(e.target.value);
            }, style: {
                padding: `${spacing.sm} ${spacing.md}`,
            }, children: [_jsx(Option, { style: {
                        display: "none",
                    }, value: countryCode, children: countryCode }), supportedCountriesForSms.map((country) => {
                    return (_jsxs(Option, { value: `${country.countryIsoCode} +${country.phoneNumberCode}`, children: [country.countryName, " +", country.phoneNumberCode] }, country.countryIsoCode));
                })] }) }));
}
const Option = /* @__PURE__ */ StyledOption(() => {
    const theme = useCustomTheme();
    return {
        color: theme.colors.primaryText,
        background: theme.colors.modalBg,
        transition: "background 0.3s ease",
        "&:hover": {
            background: theme.colors.tertiaryBg,
        },
    };
});
const Select = /* @__PURE__ */ StyledSelect((_) => {
    const theme = useCustomTheme();
    return {
        display: "block",
        padding: spacing.sm,
        boxSizing: "border-box",
        outline: "none",
        border: "none",
        borderRadius: radius.lg,
        color: theme.colors.primaryText,
        WebkitAppearance: "none",
        appearance: "none",
        cursor: "pointer",
        background: "transparent",
        "&::placeholder": {
            color: theme.colors.secondaryText,
        },
        "&[disabled]": {
            cursor: "not-allowed",
        },
        minWidth: "0px",
        maxWidth: "90px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
    };
});
//# sourceMappingURL=CountrySelector.js.map